module.exports = __webpack_public_path__ + "img/logo15.c15a0aa0.png";